module.exports = {
      id: "icons:location-pin-usage",
      viewBox: "0 0 14 18",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:location-pin-usage",
      toString: function () {
        return this.url;
      }
    }